import React from 'react';
import { Box, useTheme } from '@mui/material';
import { glass } from './glassTokens';

/**
 * GlassPaper — squared (borderRadius 2) glass surface for filter bars and table containers.
 */
export default function GlassPaper({ sx = {}, children, ...rest }) {
  const theme = useTheme();
  const g = glass(theme);

  return (
    <Box
      sx={{
        ...g.surface,
        borderRadius: 2,
        position: 'relative',
        overflow: 'hidden',
        '&:focus-visible': {
          outline: `2px solid ${theme.palette.mode === 'dark' ? '#6366F1' : '#4F46E5'}`,
          outlineOffset: 2,
        },
        ...sx,
      }}
      {...rest}
    >
      {children}
    </Box>
  );
}
